
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLeafTwotone as ObiLeafTwotoneElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-leaf-twotone.js';
 
 
 

 
 export const ObiLeafTwotone = createComponent({
   react: React,
   tagName: 'obi-leaf-twotone',
   elementClass: ObiLeafTwotoneElement,
   events: {
     
   }
  });
 
 